import {Store} from '@/lib/store';
import { observable, action, reaction } from 'mobx';
import { uploadProtected,validateId,validateKey,getDivaDoc,logUser, getDataDoc,getDocInfo } from './user';
import { filePost,validateParam,logParam,docParam } from '../interface';

export default class UserStore{

    Store: Store;
    constructor(Store: Store) {
        this.Store = Store;
    }

    @action checkUpload = async (param:filePost) => {
        try 
        {   
            const list = await uploadProtected(param);
           
            return list.result;
        } catch (error) {
            throw error;
        }
    }

    @action checkDivaId = async (param:validateParam) => {
        try 
        {   
            const list = await validateId(param);

            return list.result
        } catch (error) {
            throw error;
        }
    }

    @action checkDivaKey = async (param:validateParam) => {
        try 
        {   
            const list = await validateKey(param);
            return list.result
        } catch (error) {
            throw error;
        }
    }

    @action getDivaDoc = async (param:any) => {
        try 
        {   
            const list = await getDivaDoc(param);
            return list.result
        } catch (error) {
            throw error;
        }
    }

    @action logUser = async (param:logParam) => {
        try 
        {   
            const list = await logUser(param);
            return list
        } catch (error) {
            throw error;
        }
    }

    @action getDocData = async (param:docParam) => {
        try 
        {   
            const list = await getDataDoc(param);
            return list.result
        } catch (error) {
            throw error;
        }
    }

    @action getDocInfo = async (param:docParam) => {
        try 
        {   
            const list = await getDocInfo(param);
            return list.result
        } catch (error) {
            throw error;
        }
    }
}
